import { ContentCard, OverlayedLoader } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Button, Stack, StackItem, WithChildren } from '@optimus-web/core';

interface FormLayoutProps extends WithChildren {
    submitButtonDisabled?: boolean;
    submitButtonLoading?: boolean;
    submitButtonText?: React.ReactNode;
    title?: React.ReactNode;
    loading?: boolean;
    vertical?: boolean;
    actions?: React.ReactNode;
}

export const FormLayout: React.FC<FormLayoutProps> = ({
    children,
    submitButtonDisabled,
    title,
    loading,
    vertical = true,
    submitButtonLoading = false,
    submitButtonText = lt('Ok'),
    actions,
}) => (
    <ContentCard title={title} actions={actions}>
        <OverlayedLoader show={loading} />
        <Stack vertical={vertical} distribution={!vertical ? 'space-between' : undefined} spacing="200">
            {!vertical ? <StackItem grow>{children}</StackItem> : children}
            <Stack alignment="end" itemAlignment={!vertical ? 'end' : undefined}>
                <Button
                    loading={submitButtonLoading}
                    type="submit"
                    variant="tertiary"
                    disabled={submitButtonDisabled}
                    data-test-id="form-main-button"
                >
                    {submitButtonText}
                </Button>
            </Stack>
        </Stack>
    </ContentCard>
);
